import { getGroupedAgreementOptions } from '~/pages/GlobalBillingHub/GlobalBillingHub.utils';
export const getBillableRelationshipIds = (summaries, clientId)=>{
    const grouped = getGroupedAgreementOptions(summaries, clientId);
    return [
        ...grouped.agreements.map((option)=>option.id),
        ...grouped.adHocRelationships.map((param)=>{
            let { id } = param;
            return id;
        })
    ];
};
